<template>
  <section class="mt-12">
    <h2 class="text-2xl font-bold text-primary">
      {{ title }}
    </h2>
    <div>
      <slot />
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps<{ title: string }>();
</script>
